<section>
    <div class="L-GiftCard">
      <div class="L-GiftCard-Content Card">
        <h4 *ngIf="!isEditMode" class="L-GiftCard-Content-Title">{{ 'gift_card_form.create_title' | transloco }}</h4>

        <form class="GiftCard-Form" [class._is-edit]="isEditMode" [formGroup]="formGroup">
          <h5 class="GiftCard-Form-Subtitle"
          >
            {{ 'coupon_form.label_title' | transloco }}
            <span class="Tooltip mt-1 mr-auto"
                  [matTooltip]="'coupon_form.title_tooltip' | transloco"
                  matTooltipClass="Tooltip-Box" matTooltipPosition="above"
            ></span>
          </h5>

          <div class="PluginConfig-Line">
            <input type="text" class="form-control" maxlength="32" formControlName="title"
                   [placeholder]="'gift_card_form.title_placeholder' | transloco">
            <div class="invalid-feedback">
              {{ 'coupon_form.err_title_required' | transloco }}
            </div>
          </div>
          <h5 class="GiftCard-Form-Subtitle">{{ 'gift_card_form.label_unique_code' | transloco }}</h5>
          <div class="GiftCard-Config">
            <div class="PluginConfig-Line">
              <label class="d-flex justify-content-between">
                {{ 'coupon_form.label_prefix_optional' | transloco }}
                <span class="Tooltip mt-1 ml-1 mr-auto"
                      [matTooltip]="'gift_card_form.tooltip_prefix' | transloco"
                      matTooltipClass="Tooltip-Box" matTooltipPosition="above"
                ></span>
              </label>
              <div class="GiftCard-Prefix" [class._error]="formGroup.hasError('codeLengthError') || codeSpecialError">
                <input type="text" class="form-control" formControlName="prefix_code"
                       [maxlength]="(maxGiftCardChars - formGroup.getRawValue().code_length).toString()"
                       (keydown)="validateInput($event)"
                       (focus)="onPrefixCodeFocus()"
                       (focusout)="onPrefixCodeFocusOut()"
                       [placeholder]="'coupon_form.prefix_placeholder' | transloco">
                <div class="GiftCard-Prefix-Code-Example">
                  <span *ngIf="randomCodeString">{{ randomCodeString }}</span>
                </div>
              </div>
              <small
                class="GiftCard-Tip"
                [class._text-danger]="formGroup.hasError('codeLengthError')"
                *ngIf="prefixInputFocused; else prefixTip">
                {{ 'gift_card_form.char_count' | transloco: { n: summary.code.length } }}
              </small>
              <small class="_text-danger" *ngIf="formGroup.hasError('codeLengthError') && !prefixInputFocused">
                {{ 'gift_card_form.err_total_code_length' | transloco }}
              </small>
              <small class="_text-danger" *ngIf="codeSpecialError && !prefixInputFocused">
                {{ 'gift_card_form.err_remove_special' | transloco }}
              </small>
              <ng-template #prefixTip>
                <small *ngIf="!prefixInputFocused && !formGroup.hasError('codeLengthError') && !codeSpecialError" class="GiftCard-Tip">
                  {{ 'coupon_form.tip_keep_short' | transloco }}
                </small>
              </ng-template>
            </div>
            <div class="PluginConfig-Line">
              <label class="d-flex justify-content-between">
                {{ 'gift_card_form.label_generated_code_length' | transloco }}
              </label>
              <div>
                <input type="number" min="6" max="16" class="form-control _small mt-3" pfNumberInput
                       (change)="onCodeLengthChange($event)"
                       formControlName="code_length">
              </div>
              <small class="GiftCard-Tip">
                {{ 'coupon_form.tip_random_suffix' | transloco: { n: formGroup.getRawValue().code_length } }}
              </small>
              <div class="invalid-feedback">
                {{ 'coupon_form.err_code_length_range' | transloco }}
              </div>
            </div>
          </div>

          <div>
            <h5 class="GiftCard-Form-Subtitle">{{ 'coupon_form.section_behavior' | transloco }}</h5>

            <div class="PluginConfig-Line">
              <label class="PluginConfig-Control-Label _black _bold _with-switch-fw">
                {{ 'gift_card_form.expires_after_toggle' | transloco }}
                <pf-switch-box
                  [labelInside]="true"
                  [labelOff]="'coupon_form.switch_off' | transloco"
                  formControlName="expires_after_enabled">
                </pf-switch-box>
              </label>

              <p [class.is-hidden]="!formGroup.getRawValue().expires_after_enabled">
                {{ 'gift_card_form.expiry_law_notice' | transloco }}
              </p>


              <div class="form-inline" [class.is-hidden]="!formGroup.getRawValue().expires_after_enabled">
                <label class="mr-3">{{ 'coupon_form.label_expires_after' | transloco }}</label>
                <ng-container *ngIf="!isEditMode">
                  <div class="config-control _double _local-behavior-options">
                    <input [class.is-invalid]="
                      formGroup.get('expires_after_years').errors ||
                      formGroup.get('expires_after_days').errors" type="number" #timeInput
                      [value]="selectedTime" step="1" min="1" placeholder="0" class="form-control _medium"
                      (focus)="onTimeFocus(selectedUnit)"
                      (click)="onNumberInputClick($event)"
                      (focusout)="onTimeChange(selectedUnit, $any($event.target).value)">
                      <mat-form-field class="pf-form-field ml-2">
                        <mat-select [(value)]="selectedUnit" class="form-control _large" (selectionChange)="onUnitChange(selectedUnit)">
                          <mat-option *ngFor="let option of unitOptionDefs" [value]="option.value">
                            {{ option.labelKey | transloco }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                  </div>
                  <br>
                    <div class="error-text">
                      <small class="text-danger mb-1" *ngIf="
                      formGroup.get('expires_after_years').errors?.min ||
                      formGroup.get('expires_after_days').errors?.min">
                        {{ 'coupon_form.err_expires_empty' | transloco }}
                      </small>
                    </div>
                  <input type="hidden" class="form-control" formControlName="expires_after_years">
                  <input type="hidden" class="form-control" formControlName="expires_after_days">
                </ng-container>
                <ng-container *ngIf="isEditMode">
                  <div class="config-control _double">
                    <input type="number" [value]="editValue" class="form-control _medium" disabled>
                    <mat-form-field class="pf-form-field ml-2">
                      <mat-select [(value)]="editOption" class="form-control _large disabled" disabled="true">
                        <mat-option *ngFor="let option of unitOptionDefs" [value]="option.value">
                          {{ option.labelKey | transloco }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <div>
            <h5 class="GiftCard-Form-Subtitle">{{ 'gift_card_form.section_gift_rules' | transloco }}</h5>
            <div class="GiftCard-Config">
              <ng-container>
                <div class="PluginConfig-Line">
                  <label>{{ 'gift_card_form.label_gift_card_type' | transloco }}</label>
                  <select disabled class="form-control">
                    <option>{{ 'gift_card_form.opt_reward_incentive' | transloco }}</option>
                  </select>
                </div>

                <div class="PluginConfig-Line">
                  <label>{{ 'gift_card_form.label_gift_card_value' | transloco }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">{{currency}}</span>
                    </div>
                    <input type="number" min="0" class="form-control" formControlName="value">
                    <ng-container *ngIf="formGroup.get('value').errors; let errors">
                      <div *ngIf="errors?.required || errors?.min" class="invalid-feedback">
                        {{ 'coupon_form.err_value_gt_zero' | transloco }}
                      </div>
                      <div *ngIf="errors?.maxAmount" class="invalid-feedback">
                        {{ 'gift_card_form.err_max_amount' | transloco: { max: formattedMaxValue, currency: currency } }}
                      </div>
                    </ng-container>

                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </form>
      </div>
      <div class="L-GiftCard-Aside">
        <div class="GiftCard-Summary">
          <div class="text-dark" >
            <div class="GiftCard-Code">
                <h5>{{ 'gift_card_form.preview_title' | transloco }}</h5>
                <small class="GiftCard-Code-Warning-Text">
                  {{ 'coupon_form.preview_sample_popup' | transloco }}
                </small>
                <pre>{{summary.code}} </pre>
            </div>
            <ul class="mt-4">
              <li>{{ 'gift_card_form.summary_line' | transloco: { amount: summary.discount, currency: summary.currency } }}</li>
            </ul>
            <div class="d-flex justify-content-around mt-4">
              <button class="pf-button md outline gray" (click)="cancel()">{{ 'coupon_form.btn_cancel' | transloco }}</button>
              <button class="pf-button md filled blue" (click)="submit()">{{ 'coupon_form.btn_save' | transloco }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
</section>
<pf-loading-overlay [filter]="{only: ['new-gift-card-code']}" class="loading-overlay"></pf-loading-overlay>
